

  import { Component, Vue } from 'vue-property-decorator'
  import axios from 'axios';
  import { GF } from '../helpers/gf';
  import "../helpers/helpers";

  import WrsLabel from './wrsControls/WrsLabel.vue';
  import WrsAlert from './wrsControls/WrsAlert.vue';
  import WrsSecurityDialog from './wrsControls/WrsSecurityDialog.vue';
  import WrsWizardStepHeader from './wrsControls/WrsWizardStepHeader.vue';
  import WrsWizardStepButtons from './wrsControls/WrsWizardStepButtons.vue';
  import WrsSearchButtons from './wrsControls/WrsSearchButtons.vue';

  import WrsViText from './wrsControls/viControls/WrsViText.vue';
  import WrsViDate from './wrsControls/viControls/WrsViDate.vue';
  import WrsViCheckbox from './wrsControls/viControls/WrsViCheckbox.vue';

  import { IS_PRODUCTION_ENVIRONMENT, IS_VUEJS_ENVIRONMENT } from '../../olsStateManagement/helpers/constants';
  import { userService } from '../../olsStateManagement/services/devAuth.service';
  import AuthService from '../../olsStateManagement/services/auth.service';
  import {DEFAULT_ROOT_URL} from '../../olsStateManagement/helpers/constants'

  const authService = new AuthService();

  @Component({
    components: {
      'wrs-alert': WrsAlert,
      'wrs-security-dialog': WrsSecurityDialog,
      'wrs-wizard-step-header': WrsWizardStepHeader,
      'wrs-wizard-step-buttons': WrsWizardStepButtons,
      'wrs-search-buttons': WrsSearchButtons,
      'wrs-vi-text': WrsViText,
      'wrs-vi-checkbox': WrsViCheckbox,
      'wrs-label': WrsLabel,
      'wrs-vi-date': WrsViDate,
    },
  })

  export default class App extends Vue {
    public VM: any = {};

    public STEPIDS: any = {
      stepSelectVehicle: 1,
      stepInsurance: 2,
      stepValidation: 3,
    };

    public selectedVehicle: any = {};

    public currentOlsUser: any = {};
    public clientData: any = {};

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;
    public userName: string = ""

    public dateCheckResult: any = [];

    public loader: any = {
      loaded: false,
      loading: false,
      allowed: false,
      checkingDates: false,
    };

    public isMobile: boolean = false;

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    }

    public expandedRows: any = [];
    public mobileRowExpanded: boolean = false;
    expandRow(index: any){ 
      const indexOfRow = this.expandedRows.indexOf(index)
      if(indexOfRow > -1){
        this.mobileRowExpanded = false;
        this.expandedRows.splice(indexOfRow,1);
        return;
      }
      this.mobileRowExpanded = true;
      this.expandedRows.push(index);
    }

    //created() {
    //  if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
    //    import('../../olsStateManagement/css/olsOverrideDev.scss')
    //  }
    //}

    mounted() {
      this.startWizard();
    }

    startWizard() {
      if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
        let userData = userService.getUser();
        userData
          .then((result) => {
            this.clientData = JSON.parse(JSON.stringify(result));
            this.loadData();
            this.isAuthorized = this.clientData.isLoggedIn;
          });
      } else {

        authService.getUser()
          .then((user:any) => {
            if(user) {
              this.emailVerified = authService.emailVerified();

              if(user.profile.email_verified) {
                this.isAuthorized = authService.isAuthorized();

                if(this.isAuthorized) {

                  this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                  let pOlsUser = sessionStorage.getItem('olsUser')
                  if(pOlsUser){
                    let olsUser = JSON.parse(pOlsUser);

                    axios
                      .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true',)
                        .then(response => {
                          this.clientData = response.data;
                          this.loadData()
                      })
                      .catch(error => console.log(error))
                  }
                }
                else {
                  authService.logout();
                }
              }
              // else in store.js user is redirected to email-not-verified page!
            }
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
          })

      }
    }

    loadData() {
      this.loader.loading = true;
      this.selectedVehicle = {};

      axios
        .get('registrations/initrenewal/' + this.clientData.olsUserId + '/' + this.clientData.clientId)
        .then(response => {
          this.VM = response.data;
          this.loader.allowed = !response.data.securityError.hasError;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
        });
    }

    //#region Client Step
    isSelectedForRenewClicked() {
      this.selectedVehicle = {};
      var cnt = this.selectedCount();
      if (cnt == 1) {
        for (var index = 0, len = this.VM.vehicles.length; index < len; ++index) {
          if (this.VM.vehicles[index].isSelectedForRenew) {
            this.selectedVehicle = this.VM.vehicles[index];
          }
        }
      }
    }

    selectedCount() {
      var cnt = this.VM.vehicles.filter((item: any) => item.isSelectedForRenew == true);
      return cnt.length;
    }
    //#endregion

    //#region Step Vehicle
    //getters
    get canFindVehicles() {
      if (!this.loader.loaded || this.loader.loading) return false;

      return !this.VM.plateNumber.hasError && this.VM.plateNumber.value != '';
    }
    get anyVehicleSelected() {
      if (this.VM.runtimeError.hasError) return false;
      if (this.VM.vehicles.length == 0) return false;
      var count = this.selectedCount();
      var isReachedMax = false;

      if (count > this.VM.countOfCartItemsCanBeAdded) {
        isReachedMax = true;
        GF.setAlertWarning(this.VM.stepSelectVehicle.alert, this.VM.maximumOfCartItemsReachedError);
      }
      else {
        GF.clearAlert(this.VM.stepSelectVehicle.alert);
      }

      var anySelected = count > 0;

      return anySelected && !isReachedMax;
    }
    get insuranceRequiredOnAnySelectedVehicle() {
      if (this.VM.runtimeError.hasError) return true;
      if (this.selectedCount() == 0) return true;

      var isRequired = false;
      for (var i = 0; i < this.VM.vehicles.length; i++) {
        if (this.VM.vehicles[i].isSelectedForRenew) {
          isRequired = isRequired || this.VM.vehicles[i].insuranceRequired;
        }
      }
      return isRequired;
    }

    get canSelectVehicle() {
      if (this.VM.runtimeError.hasError) return false;
      return true;
    }

    goToInsuranceStep() {
      this.VM.currentStepId = this.STEPIDS.stepInsurance;
      this.checkInsuranceDates();
    }

    canAddToCart(fromStep: any) {
      if (fromStep == this.STEPIDS.stepSelectVehicle) {
        return !this.insuranceRequiredOnAnySelectedVehicle && !this.VM.runtimeError.hasError && this.VM.vehicles.length > 0;
      }
      else {
        return !this.VM.runtimeError.hasError && this.VM.vehicles.length > 0
          && !this.VM.companyName.hasError
          && !this.VM.policyNumber.hasError
          && !this.VM.issuedDate.hasError
          && !this.VM.expiryDate.hasError
          && !this.VM.disclamer.hasError;
      }
    }

    getStepDataRequest(isForSearch: boolean) {
      let dr = {
        clientId: this.clientData.clientId,
        olsUserId: this.clientData.olsUserId,
        plateNumber: "",
        regIds: [] as any,

        policyCompanyName: "",
        policyNumber: "",
        policyIssueDate: "",
        policyExpiryDate: "",
      };

      if (isForSearch) {
        dr.plateNumber = this.VM.plateNumber.value;
      }
      else {
        for (var i = 0; i < this.VM.vehicles.length; i++) {
          if (this.VM.vehicles[i].isSelectedForRenew) {
            dr.regIds.push(this.VM.vehicles[i].registrationId);
          }
        }

        dr.policyCompanyName = this.VM.companyName.value;
        dr.policyNumber = this.VM.policyNumber.value;
        dr.policyIssueDate = this.VM.issuedDate.value;
        dr.policyExpiryDate = this.VM.expiryDate.value;
      }

      return dr;
    }
    findVehicles() {
      this.loader.loading = true;

      let dr = this.getStepDataRequest(true);

      this.loader.loading = true;

      axios
        .post('registrations/vehciellistforrenewal', dr)
        .then(response => {
          this.VM.vehicles = response.data.vehicles;
          this.VM.stepSelectVehicle.alert = response.data.stepSelectVehicle.alert;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
        });
    }
    clearFindVehicles() {
      this.VM.currentStepId = this.STEPIDS.stepSelectVehicle;
      this.VM.plateNumber.value = "";
      this.findVehicles();
    }

    getTableHeaders() {
      return [
        { text: '', value: 'isSelectedForRenew', sortable: false, width: '50px' },
        { text: this.VM.wizardLabels.PlateNo, value: 'plateNumber', align: 'start', sortable: false, width: '' }, //100px
        { text: this.VM.wizardLabels.VehicleInfo, value: 'vehicleInfoGrid', sortable: false, width: '' }, //350px
        { text: this.VM.wizardLabels.ExpiryDate, value: 'fExpiryDate', sortable: false, width: '' }, //120px
        { text: this.VM.wizardLabels.Details, value: 'data-table-expand', width: '50px', sortable: false },
      ];
    }
    get hideDefaultFooter() {
      if (this.VM.vehicles) {
        return this.VM.vehicles.length < 10;
      }
      return false;
    }
    //#endregion

    //#region Insurance Step
    //getters
    get issuedDateExternalError() {
      if (this.dateCheckResult.length < 1) return "";

      return this.dateCheckResult[0].errorMessage;
    }
    get expiryDateExternalError() {
      if (this.dateCheckResult.length < 2) return "";

      return this.dateCheckResult[1].errorMessage;
    }

    checkInsuranceDates() {
      let dr = {
        dates: [] as any,
      };

      let fromDate = {
        "date1Label": this.VM.issuedDate.label,
        "date1Value": this.VM.issuedDate.value,
        "date2Label": this.VM.expiryDate.label,
        "date2Value": this.VM.expiryDate.value,
        "canBeInthePast": true,
        "canBeIntheFuture": false,
        "canBeBeforeDate2": true,
        "canBeAfterDate2": false,
        "errorMessage": ""
      }
      dr.dates.push(fromDate);

      let toDate = {
        "date1Label": this.VM.expiryDate.label,
        "date1Value": this.VM.expiryDate.value,
        "date2Label": this.VM.issuedDate.label,
        "date2Value": this.VM.issuedDate.value,
        "canBeInthePast": false,
        "canBeIntheFuture": true,
        "canBeBeforeDate2": false,
        "canBeAfterDate2": true,
        "errorMessage": ""
      }
      dr.dates.push(toDate);
      this.loader.checkingDates = true;
      axios
        .post('lookups/checkdates', dr)
        .then(response => {
          this.dateCheckResult = response.data.dates;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.checkingDates = false;
        });
    }
    //#endregion

    ////methods
    addToCart(fromStep: any) {
      if (this.canAddToCart(fromStep)) {
        let dr = this.getStepDataRequest(false);

        axios
          .post('registrations/calculateRenewal', dr)
          .then(response => {
            this.VM.runtimeError = response.data.runtimeError;
            if (!this.VM.runtimeError.hasAny) {
              this.VM.currentStepId = this.STEPIDS.stepValidation.stepInsurance;
            } else if (this.VM.runtimeError.hasSuccess) {
              this.VM.currentStepId = this.STEPIDS.stepValidation;
            }
            this.VM.jumpToCart = response.data.jumpToCart;
          })
          .catch(error => console.log(error))
          .finally(() => {
            if (this.VM.jumpToCart) {
              this.redirectToFullURL(this.VM.shoppingCartWebAddress);
            }
            this.loader.loading = false;
          });
      }
    }

    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

    redirectToFullURL(url:string) {
      return window.location.href = url;
    }
  }
